<template>
    <div class="container my-4 pb-5">

        <div class="row justify-content-center mb-4">
            <div class="col-lg-11">
                <div class="d-flex justify-content-end">
                    <a href="/business/dashboard" class="btn btn-link text-decoration-none">
                        <i class="fas fa-arrow-left"></i> Back to Dashboard
                    </a>
                </div>
                <div class="indicator-section mb-4">
                    <h3 class="font-weight-400 mb-4 text-center">{{ stages[stage - 1].name }}</h3>
                    <StepIndicator class="mb-4" :steps="stages" :active-step="stage - 1"/>
                </div>

                <div class="reg-form-section ">
                    <transition-group name="slide-in-left">
                        <CreateProfile
                            key="step1"
                            v-if="stage === 1"
                            :stage="stage"
                            :message="message"
                            @update-stage="updateStage"
                        />
                        <SubmitForApproval
                            key="step2"
                            :message="message"
                            v-if="stage === 2"
                        />
                    </transition-group>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

import StepIndicator from "../../../core/step-indicator.vue";
import CreateProfile from "./partials/CreateProfile.vue";
import SubmitForApproval from "./partials/SubmitForApproval.vue";
import ErrorAlert from "../../components/ErrorAlert.vue";



export default {
    name: "BillerOnboarding",
    components: {
        ErrorAlert,
        StepIndicator,
        CreateProfile,
        SubmitForApproval,
    },
    data() {
        return {
            stage: 1,
            stages: [
                { name: "Create Profile" },
                { name: "Submit for Approval" },
            ],
            agreeToTerms: false,
            stageComplete: false,
            message: "",
            error: false,
            loading: false,
        };
    },
    methods: {
        updateStage(newStage) {
            this.stage = newStage;
        },
        async setStage() {
            try {
                const response = await axios.get('/business/biller-onboarding/check-stage');
                const { message, body } = response.data;

                if (body.status === 6 || body.status === 7) {
                    window.location.href = "/business/payments";
                }
                else {
                    this.stage = body.status;
                    this.message = message;
                }
            } catch (error) {
                console.error("Error fetching biller status:", error);
                this.stage = 1;
            }
        },
    },
    mounted() {
        const url = new URL(window.location.href);
        if (!url.searchParams.has("session")) {
            url.searchParams.set("session", "true");
            window.location.href = url.toString();
        }
        this.setStage();
        setTimeout(function () {
            this.message ="";
        }.bind(this), 3000);
    },
};

</script>
<style scoped>
.indicator-section {
    position: relative;
    text-align: center;
    padding-top: 20px;
    margin-bottom: 20px;
}

.reg-form-section {
    margin-top: 20px;
}
</style>
